<template>
  <div class="alter">
    <div class="alter-headline">
      <div class="headline-left" @click="alterBack">
        <img src="../assets/system-14.png" alt="" />
      </div>
      <div class="headline-title">修改密码</div>
      <div class="headline-left"></div>
    </div>
    <div class="alter-headline-lint"></div>

    <div class="alter-block">
      <div class="block-list" v-for="(item, index) in 5" :key="index">
        <div class="list-left">
          {{
            index == 0
              ? "账号"
              : index == 1
              ? "手机号"
              : index == 2
              ? "验证码"
              : index == 3
              ? "旧密码"
              : index == 4
              ? "新密码"
              : index == 5
              ? "确认密码"
              : ""
          }}
        </div>
        <div class="list-center" :style="{ width: index == 2 ? '54%' : '80%' }">
          <div class="center-title"  v-if="index == 0">
            {{ oldName }}
          </div>
          <div class="center-input" v-if="index == 1">
            <van-field
              v-model="oldPhone"
              placeholder="请输入账号绑定的手机号"
            />
          </div>
          <div class="center-input" v-if="index == 2">
            <van-field v-model="oldVerification" placeholder="请输入验证码" />
          </div>
          <div class="center-input" v-if="index == 3">
            <el-input
              v-model="oldPassword"
              placeholder="请输入旧密码"
              show-password
            ></el-input>
          </div>
          <div class="center-input" v-if="index == 4">
            <el-input
              v-model="newPassword"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </div>

          <div class="center-input" v-if="index == 5">
            <el-input
              v-model="affirmPassword"
              placeholder="请确认新密码"
              show-password
            ></el-input>
          </div>
        </div>
        <div class="list-right" v-if="index == 2">
          <div
            v-if="index == 2"
            class="right-verification"
            :style="{
              color: oldPhone != '' ? '#fff' : '',
              background: oldPhone != '' ? '#2481D7' : '',
            }"
            @click="verificationClick"
          >
            {{ count == 0 ? "获取验证码" : count + "秒" }}
          </div>
        </div>
      </div>

      <div class="block-div">密码共8位，需包含大小写字母、数字</div>

      <div class="block-list">
        <div class="list-left">确认密码</div>
        <div class="list-center">
          <div class="center-input">
            <el-input
              v-model="affirmPassword"
              placeholder="请确认新密码"
              show-password
            ></el-input>
          </div>
        </div>
        <div class="list-right"></div>
      </div>
    </div>

    <div
      class="alter-affirm"
      :class="{
        'affirm-complete':
          oldPhone != '' &&
          oldVerification != '' &&
          oldPassword != '' &&
          newPassword != '' &&
          affirmPassword != '',
      }"
      @click="alterPassword"
    >
      确认修改
    </div>
  </div>
</template>
  
  <script>
import {
  userRegister,
  userforget,
  userforgetup,
  userPhone,
  postcode,
} from "../api/login";

import { userInfoGet } from "../api/index";

var throttle = require("../plugins/throttle"); // 防抖
var verify = require("../plugins/verify"); // 手机号校验
import { md5 } from "../plugins/md5";

export default {
  data() {
    return {
      alterIndex: 0,
      //--------------
      oldName: "", // 旧的昵称
      oldPhone: "", // 旧的手机号
      oldVerification: "", // 旧的验证码
      oldPassword: "", // 旧的密码
      newPassword: "", // 新的密码
      affirmPassword: "", // 确认密码

      count: 0, // 旧的验证码倒计时
      timer: null, // 旧的验证码倒计时
      //---------------
    };
  },
  created() {
    this.userInfoGetMet();
  },
  mounted() {
    this.backTop()
    window.onload = function () {
      document.addEventListener("touchstart", function (e) {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
      });
    };
  },
  methods: {
    backTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    userInfoGetMet() {
      let params = {};

      userInfoGet(params).then((res) => {
        if (res.code == 200) {
          this.oldName = res.result.username;
        }
      });
    },
    //------------
    alterBack() {
      this.$router.go(-1);
    },

    //-------------更换手机号
    verificationClick() {
      if (this.count != 0) {
        return;
      }

      if (this.oldPhone == "") {
        this.$message.warning("请先输入手机号！");
        return;
      }

      if (!verify.codeVerification(this.oldPhone)) {
        this.$message.warning("手机号格式有误！");
        return;
      }

      this.generationVerificationMet(0);
    },
    //------------验证码
    generationVerificationMet: throttle.throttle(function (index) {
      let params = {
        phone: this.oldPhone,
        type: 2,
        // alterIndex == 0 更换手机号
      };

      postcode(params).then((res) => {
        if (res.message == "") {
          if (index == 0) {
            //倒计时时间
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        }
      });
    }, 2000),
    // 修改密码
    alterPassword() {
      if (
        this.oldPhone == "" ||
        this.oldVerification == "" ||
        this.oldPassword == "" ||
        this.newPassword == "" ||
        this.affirmPassword == ""
      ) {
        this.$message.warning(
          this.oldPhone == ""
            ? "请先输入账号绑定的手机号！"
            : this.oldVerification == ""
            ? "请先输入验证码！"
            : this.oldPassword == ""
            ? "请先输入旧密码！"
            : this.newPassword == ""
            ? "请先输入新密码！"
            : this.affirmPassword == ""
            ? "请先确认新密码！"
            : ""
        );
        return;
      }

      if (this.newPassword != this.affirmPassword) {
        this.$message.warning("两次密码不一致");
        return;
      }

      let params = {
        code: this.oldVerification,
        password: md5(this.newPassword),
        phone: this.oldPhone,
        username: this.oldName,
      };

      userforgetup(params).then((res) => {
        if (res.code == 200) {
          this.$toast({
            message: "修改成功",
            icon: require("../assets/personage-10.png"), // 或者 'custom' 来使用自定义图片
            duration: 2000,
          });

          setTimeout(() => {
            this.alterBack();
          }, 2000);
        }
      });
    },
    //-----------------------------------------
  },
};
</script>
  
  <style lang="less" scoped>
.alter {
  min-height: 100vh;
  background: #f5f5f5;
  position: relative;

  .alter-headline {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    height: 47px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .headline-left {
      width: 25px;
      height: 25px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .headline-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 17px;
      color: #222222;
    }
  }

  .alter-headline-lint {
    height: 47px;
    width: 100%;
  }

  .alter-block {
    .block-list {
      padding: 0 12px;
      box-sizing: border-box;
      background: #fff;
      height: 58px;
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ececed;

      .list-left {
        width: 20%;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 15px;
        color: #222222;
      }

      .list-center {
        .center-title {
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 15px;
          color: #222222;
        }

        .center-input {
          /deep/ .van-cell {
            padding: 0;
            background: rgba(255, 255, 255, 0);
          }

          /deep/ .van-field__control::placeholder {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 15px;
            color: #888888;
          }

          /deep/ .el-input__inner {
            padding: 0;
            border: 0;
          }

          /deep/ .el-input__inner::placeholder {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 15px;
            color: #888888;
          }
        }
      }

      .list-right {
        width: 20%;
        margin-left: 2%;
        .right-verification {
          width: 85px;
          height: 31px;
          background: #e0e0e0;
          border-radius: 15.5px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: rgba(255, 255, 255, 1);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .block-list:last-child {
      border-bottom: 0;
    }

    .block-div {
      padding: 0 12px;
      box-sizing: border-box;
      height: 36px;
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      background: #f5f5f5;
      color: #ff5858;
    }
  }

  .alter-affirm {
    margin: 20px 10px 0;
    height: 46px;
    background: #e6e6e6;
    border-radius: 5px;
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 800;
    font-size: 15px;
    color: #c5c5c5;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 1px;
  }

  .affirm-complete {
    background: linear-gradient(90deg, #609ce6 0%, #5084da 100%);
    color: #ffffff;
  }
}
</style>